export default __webpack_public_path__ + "assets/images/Images-9df01d47563e8c55b5b604e59d06cebc.svg";